import z from 'zod'
import { createFileRoute } from '@tanstack/react-router'
import { ComplianceAuditsPage } from '@/features/ndis-standards/audits'
import { requireActiveSubscription } from '@/lib/middleware'

const searchSchema = z.object({
  audit: z.string().optional(),
  /** Phase 3c: opens the full checklist dialog for this audit. `?audit=` now
   *  sends you to the one-question-at-a-time runner instead. */
  all: z.string().optional(),
  from: z.string().optional(),
  obligation: z.string().optional(),
})

export const Route = createFileRoute('/_authenticated/_organization/compliance/audits')({
  beforeLoad: async () => requireActiveSubscription(),
  validateSearch: searchSchema,
  component: ComplianceAuditsPage,
})
